import { render, staticRenderFns } from "./TranslatorForm.vue?vue&type=template&id=5cb2beb6&"
import script from "./TranslatorForm.vue?vue&type=script&lang=js&"
export * from "./TranslatorForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorForm.vue?vue&type=style&index=0&id=5cb2beb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports